import { store } from "../store";
import { API_CONFIG } from "./constants/constant";
import http from "./http.service";

const fundTransferVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: `FT_VERIFY`,
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.verify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fundTransferConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: `FT_CONFIRM`,
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
      bulkTransfer: false,
      ...data,
    };
    const response = await http.post(API_CONFIG.confirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const repaymentTransferVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "FT_RESUBMIT_VERIFY",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.rePaymentVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const repaymentTransferConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "FT_RESUBMIT_CONFIRM",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      mode: "AA",
      bulkTransfer: false,
      ...data,
    };
    const response = await http.post(API_CONFIG.rePaymentConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const transferOptions = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      authUsers: [],
      cardCode: "",
      cardCodeValue: "",
      module: "TRANSFEROPTIONS",
      requestId: "FUNDTRANSFER",
      profileId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.transferOptions, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyOrCancelScheduledTransferVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FT_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.modifyOrCancelScheduledTransferVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const modifyOrCancelScheduledTransferConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FT_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.modifyOrCancelScheduledTransferConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const authVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FT_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.authVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const authConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FT_AUTH_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.authConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const reSubmitTransferVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "MODIFY_CANCEL_VERIFY",
      profileId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.reSubmitTransferVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const reSubmitTransferConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "MODIFY_CANCEL_VERIFY",
      profileId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.reSubmitTransferConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const addAsPayee = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FTVERIFYIAT",
      requestId: "FUNDTRANSFER",
      profileId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.addAsPayee, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const generateTokenVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CARDLESSCASHOUT",
      requestId: "CARDLESSCASHOUT_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.generateTokenVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const generateTokenConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CARDLESSCASHOUT",
      requestId: "CARDLESSCASHOUT_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.generateTokenConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getTokenRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CARDLESSCASHOUT",
      requestId: "GET_CARDLESSCASHOUT_RECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.getTokenRecords, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const tokenAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CARDLESSCASHOUT",
      requestId: "CARDLESSCASHOUT_AUTH_VERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.tokenAuthVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const tokenAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CARDLESSCASHOUT",
      requestId: "CARDLESSCASHOUT_AUTH_CONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.tokenAuthConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const viewToken = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "CARDLESSCASHOUT",
      requestId: "CARDLESS_VIEW_TOKEN",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.viewToken, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getTxnCurrency = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "TRANSFER_OPTIONS",
      ...data,
    };
    const response = await http.post(API_CONFIG.getTxnCurrency, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getFspCodes = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "FSPCODES",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.getFspCodes, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getEAPBankList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "EAPT_BANK_DETAILS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.getEAPBankList, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getRemarks = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "REMARKS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.getRemarks, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const ftGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "GET_RECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.ftGetRecords, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getConvertedAmount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "COVERSION_AMOUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.getConvertedAmount, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const internationalfileUpload = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FTFILEUPLOAD",
      requestId: "FTFILEUPLOAD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.postUpload(
      API_CONFIG.fileInternationalUpload,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileUploadInitVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    data.append("requestId", "FILEUPLOAD_INITIVERIFY");
    data.append("userGroupId", parseInt(profileDetails["profileId"] || 0));
    data.append("language", app.language);
    data.append("ipAddress", "0.0.0.0");
    data.append("channelType", "WEB");
    data.append("userName", app?.loginDetails?.userName);
    const response = await http.postUpload(
      API_CONFIG.fileUploadInitVerify,
      data
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileUploadInitConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    data.append("requestId", "FILEUPLOAD_INITCONFIRM");
    data.append("userGroupId", parseInt(profileDetails["profileId"] || 0));
    data.append("language", app.language);
    data.append("ipAddress", "0.0.0.0");
    data.append("channelType", "WEB");
    data.append("userName", app?.loginDetails?.userName);
    const response = await http.postUpload(
      API_CONFIG.fileUploadInitConfirm,
      data
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getFileProcessList = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FILEUPLOAD",
      requestId: "FILEUPLOADPROCESSLIST",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.getFileProcessList, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileUploadGetRecords = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FILEUPLOAD",
      requestId: "FILEUPLOAD_GETRECORDS",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.fileUploadGetRecords,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileUploadAuthVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FILEUPLOAD",
      requestId: "FILEUPLOAD_AUTHVERIFY",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.fileUploadAuthVerify,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileUploadAuthConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FILEUPLOAD",
      requestId: "FILEUPLOAD_AUTHCONFIRM",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.fileUploadAuthConfirm,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const fileUploadPendingCount = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FILEUPLOAD",
      requestId: "SALARY_FILE_UPLOAD_PENDING_COUNT",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.fileUploadPendingCount,
      reqParams
    );
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const bulkTransferVerify = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BULK_FT_VERIFY ",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),

      ...data,
    };
    const response = await http.post(API_CONFIG.bulkTransferVerify, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const bulkTransferConfirm = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "BULK_FT_CONFIRM",
      module: "FUNDTRANSFER",
      userGroupId: parseInt(profileDetails["profileId"] || 0),

      ...data,
    };
    const response = await http.post(API_CONFIG.bulkTransferConfirm, reqParams);
    return { status: response.status, data: response.data };
  } catch (err) {
    return Promise.reject(err);
  }
};

const getUploadHistory = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      requestId: "FILEUPLOAD_GETRECORDS",
      module: "FILEUPLOAD",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(
      API_CONFIG.salaryDownloadRecords,
      reqParams
    );
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const swiftCountryLookUp = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "SWIFT_LOOKUP",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.swiftCountryLookUp, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const swiftCodeLookUp = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      module: "FUNDTRANSFER",
      requestId: "SWIFT_LOOKUP",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
      ...data,
    };
    const response = await http.post(API_CONFIG.swiftCodeLookUp, reqParams);
    return { status: response.status, data: response.data["data"] };
  } catch (err) {
    return Promise.reject(err);
  }
};

const cardlessViewToken = async (data) => {
  try {
    const { app } = store.getState();
    const { profileDetails } = app;
    const reqParams = {
      ...data,
      requestId: "CARD_LESS_CASH_VIEW_TOKEN",
      module: "CARDLESSCASH",
      userGroupId: parseInt(profileDetails["profileId"] || 0),
    };
    const response = await http.post(API_CONFIG.cardlessViewToken, reqParams);

    return { status: response.status, data: response.data };
  } catch (err) {
    throw err.response.data;
  }
};

const TransferService = {
  fundTransferVerify,
  transferOptions,
  fundTransferConfirm,
  modifyOrCancelScheduledTransferVerify,
  modifyOrCancelScheduledTransferConfirm,
  authVerify,
  authConfirm,
  reSubmitTransferVerify,
  reSubmitTransferConfirm,
  addAsPayee,
  generateTokenVerify,
  generateTokenConfirm,
  getTokenRecords,
  tokenAuthVerify,
  tokenAuthConfirm,
  viewToken,
  getTxnCurrency,
  getFspCodes,
  ftGetRecords,
  getRemarks,
  getConvertedAmount,
  fileUploadInitVerify,
  fileUploadInitConfirm,
  getFileProcessList,
  fileUploadGetRecords,
  fileUploadAuthVerify,
  fileUploadAuthConfirm,
  fileUploadPendingCount,
  bulkTransferVerify,
  bulkTransferConfirm,
  getUploadHistory,
  internationalfileUpload,
  repaymentTransferVerify,
  repaymentTransferConfirm,
  swiftCodeLookUp,
  swiftCountryLookUp,
  getEAPBankList,
  cardlessViewToken,
};

export default TransferService;
